<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t('View Account Receivable Information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />
        <v-layout row wrap class="invoice-content">
          <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
            <v-layout row wrap>
              <v-flex xs12 style="text-align: center" class="only-for-print" pb-3>
                <strong>{{ $t('Account Receivable') }}</strong>
              </v-flex>

              <v-flex xs10 class="pb-3">
                <div class="caption no-select">{{ $t('Customer') }}</div>
                <strong>{{ viewInfo.customer_name || '-' }}</strong>
              </v-flex>

              <v-flex xs4 class="pb-3">
                <div class="caption no-select">
                  {{ `${$t('Total Debit')} (${systemCurrency})` }}
                </div>
                <strong>{{ viewInfo.total_debit | currency }}</strong>
              </v-flex>

              <v-flex xs4 class="pb-3">
                <div class="caption no-select">
                  {{ `${$t('Total Balance')} (${systemCurrency})` }}
                </div>
                <strong>{{ viewInfo.total_balance | currency }}</strong>
              </v-flex>

              <v-flex xs4 class="pb-3">
                <div class="caption no-select">
                  {{ `${$t('Total Credit')} (${systemCurrency})` }}
                </div>
                <strong>{{ viewInfo.total_credit | currency }}</strong>
              </v-flex>

              <invoice-footer
                :showSignatureSection="false"
                :accountantName="''"
                :payerRecipientName="''"
                :payerOrRecipient="''"
                class="only-for-print"
              />
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      viewInfo: 'accountReceivable/getAccountReceivableInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    printMe() {
      // we pass true parameter to the function
      // in this way we know that we print invoice and some other style should apply
      // if we don't pass anything it will be false which means
      // we don't print invoice and other styles won't be applied
      helpers.doPrinting()
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
